interface EventContactInfoProps {
  contactInfo:
    | {
        email?: string;
        phone?: string;
      }
    | undefined;
}

/**
 * Email / phone contact block. Renders nothing when the event has neither.
 */
export const EventContactInfo = ({ contactInfo }: EventContactInfoProps) => {
  if (!contactInfo || (!contactInfo.email && !contactInfo.phone)) return null;

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact</h2>
      <div className="space-y-2">
        {contactInfo.email && (
          <div className="flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            <a
              href={`mailto:${contactInfo.email}`}
              className="text-primary-600 hover:text-primary-700 hover:underline"
            >
              {contactInfo.email}
            </a>
          </div>
        )}
        {contactInfo.phone && (
          <div className="flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            <a
              href={`tel:${contactInfo.phone}`}
              className="text-primary-600 hover:text-primary-700 hover:underline"
            >
              {contactInfo.phone}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
